const { isTenantChatHead } = require('./insideChatHeader');

function recentTenantHeading(row) {
  const name = String((row && row.name) || "").trim();
  const property = String((row && row.property) || "").trim();
  if (name && property) return `${name} ${property}`;
  return name || property;
}

function recentTenantMessageStamp(value) {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(date);
  const pick = (type) => {
    const part = parts.find((item) => item.type === type);
    return part ? part.value : "";
  };
  const period = pick("dayPeriod").toLowerCase().startsWith("a") ? "am" : "pm";
  return `${pick("month")}/${pick("day")}/${pick("year").slice(-2)} ${pick("hour")}:${pick("minute")}${period}`;
}

function recentTenantPeopleId(row) {
  const id = Number(row && row.peopleId);
  return Number.isFinite(id) && id > 0 ? id : null;
}

function findTenantChatHead(chats, peopleId) {
  const id = recentTenantPeopleId({ peopleId });
  if (id == null) return null;
  return (
    (chats || []).find(
      (chat) => isTenantChatHead(chat) && Number(chat.personId) === id,
    ) || null
  );
}

function initialsFromName(name) {
  const letters = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('');
  return letters || 'T';
}

/** Fields for a tenant chat head opened from a recent-message card. */
function tenantChatHeadFromRecentRow(row) {
  const peopleId = recentTenantPeopleId(row);
  if (peopleId == null) return null;
  const name = String((row && row.name) || '').trim() || 'Tenant';
  const conversationId = Number(row && row.conversationId);
  return {
    initials: initialsFromName(name),
    displayName: name,
    fullName: name,
    personId: peopleId,
    userId: null,
    groupId: null,
    groupName: null,
    unreadCount: 0,
    emergencyUnread: 0,
    lastMessageId: 0,
    lastViewedMessageId: 0,
    _tenantConversationId:
      Number.isFinite(conversationId) && conversationId > 0
        ? conversationId
        : null,
  };
}

const RECENT_FEATURE_HINT_KEY = 'ichat-recent-25-hint-seen';

function recentFeatureHintSeen(storage) {
  try {
    return storage.getItem(RECENT_FEATURE_HINT_KEY) === '1';
  } catch {
    return true;
  }
}

function markRecentFeatureHintSeen(storage) {
  try {
    storage.setItem(RECENT_FEATURE_HINT_KEY, '1');
  } catch {
    /* storage can be unavailable */
  }
}

/** Place the callout so its arrow points left at the 25 button. */
function recentFeatureHintPosition({
  panelLeft,
  panelTop,
  clientLeft,
  clientTop,
  buttonTop,
  buttonRight,
  buttonHeight,
  calloutHeight,
}) {
  const center = buttonTop + buttonHeight / 2 - panelTop - (clientTop || 0);
  const height = Number(calloutHeight) > 0 ? Number(calloutHeight) : 40;
  const top = Math.max(8, Math.round(center - height / 2));
  const left = Math.round(buttonRight - panelLeft - (clientLeft || 0) + 6);
  return { top: `${top}px`, left: `${left}px` };
}

const RECENT_TENANTS_HINT_KEY = 'ichat-recent-tenants-hint-seen';

function recentTenantsHintSeen(storage) {
  try {
    return storage.getItem(RECENT_TENANTS_HINT_KEY) === '1';
  } catch {
    return true;
  }
}

function markRecentTenantsHintSeen(storage) {
  try {
    storage.setItem(RECENT_TENANTS_HINT_KEY, '1');
  } catch {
    /* storage can be unavailable */
  }
}

module.exports = {
  recentTenantHeading,
  recentTenantMessageStamp,
  recentTenantPeopleId,
  findTenantChatHead,
  tenantChatHeadFromRecentRow,
  RECENT_TENANTS_HINT_KEY,
  recentTenantsHintSeen,
  markRecentTenantsHintSeen,
  RECENT_FEATURE_HINT_KEY,
  recentFeatureHintSeen,
  markRecentFeatureHintSeen,
  recentFeatureHintPosition,
};
